const ShipperRequestTypeKeys = {
  TITLE: "title",
  REQUEST_TYPE: "requestType"
}

export default ShipperRequestTypeKeys
